import React from 'react';
import SvgIcon from './SvgIcon';

const FacilityAirport = props => (
    <SvgIcon viewBox="0 0 48 48" {...props}>
        <g id="Icon-Audit-v1.3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Stabilitas-Icons-Copy" transform="translate(-1853.000000, -4068.000000)">
                <g id="icon/facilities-airport-copy" transform="translate(1853.000000, 4068.000000)">
                    <rect id="Rectangle-Copy-4" x="0" y="0" width="48" height="48"></rect>
                    <path
                        d="M44.1818182,28 L20.5454545,28 L20.5454545,31.6 L42.3636364,31.6 L42.3636364,42.4 L38.7272727,42.4 L38.7272727,35.2 L35.0909091,35.2 L35.0909091,42.4 L31.4545455,42.4 L31.4545455,35.2 L27.8181818,35.2 L27.8181818,42.4 L24.1818182,42.4 L24.1818182,35.2 L20.5454545,35.2 L20.5454545,42.4 L16.9090909,42.4 L16.9090909,28 L6,28 L6,44.2 C6,45.1941125 6.81402773,46 7.81818182,46 L44.1818182,46 C45.1859723,46 46,45.1941125 46,44.2 L46,29.8 C46,28.8058875 45.1859723,28 44.1818182,28 Z"
                        id="Path"
                        fill="currentColor"
                        fillRule="nonzero"
                    ></path>
                    <path
                        d="M19.659523,6.48499998 C19.3212019,6.00104777 18.7781094,5.71430556 18.1997828,5.7142857 L12.8000041,5.7142857 L12.8000041,2 L9.20015162,2 L9.20015162,5.7142857 L3.80037291,5.7142857 C3.22179817,5.71414194 2.6784279,6.00097516 2.34001644,6.48517577 C2.00160499,6.96937637 1.90941327,7.59190808 2.09224291,8.15828569 L3.89216915,13.7297142 C4.13708859,14.4884365 4.82523757,15.0001925 5.60029915,15 L16.3998566,15 C17.1749182,15.0001925 17.8630671,14.4884365 18.1079866,13.7297142 L19.9079128,8.15828569 C20.0906248,7.59175493 19.9982003,6.96913458 19.659523,6.48499998 Z"
                        id="Path"
                        fill="currentColor"
                        fillRule="nonzero"
                    ></path>
                    <rect
                        id="Rectangle"
                        fill="currentColor"
                        fillRule="nonzero"
                        x="6"
                        y="18"
                        width="11"
                        height="6"
                    ></rect>
                </g>
            </g>
        </g>
    </SvgIcon>
);

FacilityAirport.displayName = 'FacilityAirportIcon';

export default FacilityAirport;
